import { Controller } from "@hotwired/stimulus"
import { Loggable } from "./concerns/loggable"
import { SafeTimeoutable } from "./concerns/safe_timeoutable";

const ACTIVITY_EVENTS = ["mousemove", "keydown", "click", "touchstart", "scroll"]

export default class extends Controller {
  static targets = [  ]

  static values = {
    // Required: number of seconds between reloads
    reloadEvery: Number,
    // Optional: number of seconds the user must be idle before a reload occurs
    idleFor: Number
  }

  initialize(){
    Loggable(this, {debug: false})
    SafeTimeoutable(this)
    this.lastActivityAt = Date.now()
    this._activityHandler = (event) => this.updateLasActivity(event)
  }

  connect(){
    this.queueReload()

    // Track user activity to determine idleness
    this.addActivityListeners()
  }

  disconnect(){
    this.removeActivityListeners()
  }

  queueReload(){
    const reloadEverySeconds = this.reloadEveryValue
    const reloadEveryMs = reloadEverySeconds * 1000
    this.log(`queueing reload in ${reloadEverySeconds}s (${reloadEveryMs} ms).`)

    this.safeSetTimeout(() => this.doReload(), reloadEveryMs)
  }

  doReload(){
    // If an idle threshold is provided, only reload when the user has been idle long enough
    if (this.hasIdleForValue) {
      const idleForMs = this.idleForValue * 1000
      const idleMs = Date.now() - this.lastActivityAt

      if (idleMs < idleForMs) {
        const remaining = Math.max(idleForMs - idleMs, 50)
        this.log(`user not idle long enough (${Math.round(idleMs)}ms < ${idleForMs}ms). retrying in ${remaining} ms.`)
        this.safeSetTimeout(() => this.doReload(), remaining)
        return
      }
    }

    this.log("reloading")
    Turbo.visit(location.toString())
  }

  // --- Activity tracking ---------------------------------------------------
  addActivityListeners(){
    ACTIVITY_EVENTS.forEach((evt) => window.addEventListener(evt, this._activityHandler, {passive: true}))
  }

  removeActivityListeners(){
    ACTIVITY_EVENTS.forEach((evt) => window.removeEventListener(evt, this._activityHandler, {passive: true}))
  }

  updateLasActivity(_event){
    this.lastActivityAt = Date.now()
  }
}
